import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import EventPage from "./pages/EventPage";
import RegisterPage from "./pages/RegisterPage";
import EventDetailPage from "./pages/EventDetailPage";
import CreateEventPage from "./pages/CreateEventPage";
import EditEventPage from "./pages/EditEventPage";

import ManageUsersPage from "./pages/ManageUsersPage";
import UserDetailPage from "./pages/UserDetailPage";
import AllUsersPage from "./pages/AllUsersPage";
import ProfilePage from "./pages/ProfilePage";
function App() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100 text-gray-900">
      {" "}
      {/* Tailwind klasy dla globalnego stylu */}
      <Router>
        <Navbar />
        <main className="flex-grow">
          {" "}
          {/* Dynamiczna przestrzeń dla głównej zawartości */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/events" element={<EventPage />} />
            <Route path="/events/:id" element={<EventDetailPage />} />
            <Route path="/create-event" element={<CreateEventPage />} />
            <Route path="/events/edit/:id" element={<EditEventPage />} />
            <Route path="/users" element={<ManageUsersPage />} />
            <Route path="/users/:id" element={<UserDetailPage />} />
            <Route path="/all-users" element={<AllUsersPage />} />
            <Route path="/profile" element={<ProfilePage />} />

          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
